import React from "react";

import { TopBar } from "@weezevent/nacre";
import Style from "./topBarModules.module.css";
import AccountComponent from "./components/account";

export default function TopBarModules() {
	return (
		<TopBar.Modules className={Style["top-bar-modules"]}>
			<AccountComponent />
		</TopBar.Modules>
	);
}
